import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetShowStyle0 = gravityIconIndividualCss;

const GravityIconAssetShow = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'a5cb0abaecbe08c204452cebdddfc115e827a911', color: this.color, size: this.size }, h("svg", { key: '947b7d437fef9367d902d7db8de1af04b1e68c73', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a958de9a4790a11138e887838e83fb81f63a9bdb', d: "m11.89 12.738 1.7.15c.27.03.34.18.11.33l-1.38 1.17.49 1.63c.07.2-.05.35-.27.2l-1.54-1-1.45.99c-.27.15-.35.05-.27-.2l.49-1.64-1.36-1.14c-.21-.17-.17-.35.1-.35l1.73-.16.59-1.59c.1-.25.26-.25.37 0l.69 1.61Z", fill: "currentColor" }), h("path", { key: '296fafd8d35af8a02382241c6f38965c11af06a7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 8.218h-5.36l2.43-3a.5.5 0 0 0-.08-.7l-.39-.3a.49.49 0 0 0-.7.08l-3.17 3.92-5.05-5.07a.5.5 0 0 0-.71 0l-.35.35a.5.5 0 0 0 0 .71l4 4H3.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-9.99a.5.5 0 0 0-.5-.5Zm-1 1.5v8h-13v-8h13Z", fill: "currentColor" }))));
    }
};
GravityIconAssetShow.style = GravityIconAssetShowStyle0;

export { GravityIconAssetShow as gravity_icon_asset_show };

//# sourceMappingURL=gravity-icon-asset-show.entry.js.map